import IconComponent from "app/shared-components/IconComponent";
import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import moment from "moment";


const Employee = () => {

  const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;

  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState();
  const [gridApi, setGridApi] = useState(null);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [deleteDisable, setDeleteDisable] = useState(true);
  const [error, setError] = useState("")
  const perPage = 10;
  const gridRef = useRef();
  const navigate = useNavigate();
  const [columnDefs, setColumnDefs] = useState([
    { field: 'employeeId', enableRowGroup: true },
    { field: 'employeeName', enableRowGroup: true, headerName:"Employee Name" },
    { field: 'department', enableRowGroup: true },
    { field: 'designation', enableRowGroup: true },
    { field: 'martialStatus', enableRowGroup: true, headerName:"Marital Status" },
    { field: 'gender', enableRowGroup: true },
    { field: 'email', enableRowGroup: true },
    { field: 'dateOfBirth', enableRowGroup: true, cellRenderer: handleDateFormat },
  ]);

  function handleDateFormat (props) {
    return props.value && moment(props.value).format("DD-MM-YYYY");
  };

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(url + `?sort=name,asc&size=1000`);
      let employees = list.data?._embedded?.employees;
      employees = employees.map((employee) => {
        const empFullName = `${employee.empFirstName} ${employee.empMiddleName} ${employee.empLastName}`;
        employee.employeeName = empFullName;
        return employee;
    });
      setRowData(employees);
    } catch (error) {
      setError(error.message);
    }
  }

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);

  const handlePurge = (e) => {
    selectedRows.map(async (row) => {
      try {
        await OAuthService.deleteData(url, row.employeeId);
        setSuccessMsg("Data deleted Successfully")
        setSnackState(true);
        loadData();
      } catch (error) {
        console.log("eror", error);
        setError(error.message);
      }
    })
  };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: 'Employees.xlsx',
      sheetName: 'Employees'
    }
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  }

  const onRowDoubleClicked = (params) => {
    navigate('/editEmployee/' + selectedRows[0]?.employeeId)
  }

  useEffect(() => {
    if (selectedRows.length > 0) {
      setDeleteDisable(false)
    } else {
      setDeleteDisable(true)
    }
  }, [selectedRows])

  return (
    <>
      <ListPageHeader
        componentName="Employee"
        onBtExport={onBtExport}
        handlePurge={handlePurge}
        addPageLink="/addEmployee"
        pageName="Employee List"
        error={error}
        deleteDisable={deleteDisable}
        successMsg={successMsg}
        gridRef={gridRef}
        snackState={snackState}
      />
      <div className="h-full">
        <AgGridTable
          columnDefs={columnDefs}
          rowData={rowData}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          onRowDoubleClicked={onRowDoubleClicked}
          gridRef={gridRef}
          paginationPageSize={perPage}
          cacheBlockSize={perPage}
          saveGridStateName={'employee'}
        />
      </div>
    </>
  )
}

export default Employee;